export default "__VITE_ASSET__Btubg4i2__"